import '../css/app.css';
import '../css/theme.css';
import './bootstrap';

import { createRoot } from 'react-dom/client';
import { useEffect, useState } from 'react';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';

import Loader from "@/Components/dclics/Loader";
import { useLoading } from '@/hooks/useLoading';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

const queryClient = new QueryClient();

// Vérification de l'environnement localhost
const isLocalhost = () => {
    return true
  return window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname.includes('192.168.');
};

// Fonction de log conditionnelle
const conditionalLog = (message, style, data) => {
  if (isLocalhost()) {
    data ? console.log(message, style, data) : (style ? console.log(message, style) : console.log(message));
  }
};

// Wrapper pour intégrer le Loader avec le state global
function AppWithLoader({ App, props }) {
    const { isLoading, validation } = useLoading();
    
    // Utiliser un état local pour assurer le rendu correct du loader
    const [showLoader, setShowLoader] = useState(false);
    
    // Écouteurs d'événements pour les validations
    useEffect(() => {
        // Fonction pour démarrer le loader
        const handleValidationStart = () => {
            conditionalLog('%c💾 LOADER DÉSACTIVÉ pour les validations', 'color: #FF5733; font-weight: bold');
        
        };
        
        // Fonction pour arrêter le loader après un délai
        const handleValidationComplete = () => {
            // Garder le loader actif pendant un moment après la fin de la validation
            setTimeout(() => {
                conditionalLog('%c💾 LOADER DÉSACTIVÉ (Validation terminée)', 'color: #F59E0B; font-weight: bold');
                setShowLoader(false);
            }, 800);
        }
        
        // Ajout des écouteurs d'événements
        document.addEventListener('validation:start', handleValidationStart);
        document.addEventListener('validation:complete', handleValidationComplete);
        document.addEventListener('validation:error', handleValidationComplete);
        
        // Nettoyage
        return () => {
            document.removeEventListener('validation:start', handleValidationStart);
            document.removeEventListener('validation:complete', handleValidationComplete);
            document.removeEventListener('validation:error', handleValidationComplete);
        };
    }, []);
    
    // Effet pour synchroniser l'état du loader avec isLoading
    useEffect(() => {
        // Log des états actuels
        conditionalLog('%c💾 État du loader:', 'color: #FF5733; font-weight: bold', {
            isLoading,
            'validation.isValidating': validation.isValidating,
            'showLoader actuel': showLoader
        });
        
        // Afficher le loader uniquement pour les requêtes réseau, pas pour les validations
        if (isLoading && !validation.isValidating) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [isLoading]);
    
    return (
        <>
            <Loader isVisible={showLoader} />
            <QueryClientProvider client={queryClient}>
                <App {...props} />
            </QueryClientProvider>
        </>
    );
}

createInertiaApp({
    title: (title) => `${title} - dclics`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.jsx`,
            import.meta.glob('./Pages/**/*.jsx')
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(<AppWithLoader App={App} props={props} />);
    },
    progress: false,
});